import { ThemeProvider } from '@mui/material/styles';
import { Stack } from '@mui/material';
import { theme } from './theme';
import { AppLayout } from './components/layout';
import { Calculator, SkillsManager, StructureBonuses } from './components/calculator';
import { CacheStatus } from './components/cache';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AppLayout>
        <Stack spacing={3}>
          {/* Cache Management */}
          <CacheStatus />

          {/* Skills Configuration */}
          <SkillsManager />

          {/* Structure/Citadel Bonuses */}
          <StructureBonuses />

          {/* Main Calculator */}
          <Calculator />
        </Stack>
      </AppLayout>
    </ThemeProvider>
  );
}

export default App;
